import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { clearBotState } from "../../store/slices/botSlice";
import { setCustomGridMode } from "../../store/slices/customBotSlice";
import { useParams } from "react-router-dom";
import TickerChooseList from "./components/TickerChooseList";
import Header from "../../_modules/Header/Header";
import PageLayout from "../../_components/PageLayout";
import { EntityType } from "../../_app/types";

const TickerChoosePage = () => {
  const params = useParams<{ entity: EntityType }>();
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.user);

  const tickers = useSelector((state: RootState) => state.shared.tickers);

  useEffect(() => {
    dispatch(clearBotState());
    dispatch(setCustomGridMode(false));
  }, []);

  return (
    <PageLayout
      contentSx={{ padding: "20px 8px 5px" }}
      header={<Header pageTitle={"Choose pair"} needBack={true} />}
    >
      <TickerChooseList
        tickers={
          params.entity === "strategy" && user.activeAccount.market !== "BYBIT" ? [] : tickers
        }
        entity={params.entity ?? "bot"}
      />
    </PageLayout>
  );
};

export default TickerChoosePage;
